
import axios, { AxiosResponse } from "axios";
import { getSingleUrl, getTablesUrl, getUrl } from "./getUrl";
import { LookupTablesApiParameters, SearchFilters } from "../types/v1_schemas";

export const QueryApi = async (searchFilters: SearchFilters, signal: AbortSignal, callback: (response: AxiosResponse) => void, error: (error: any) => void) => {
  const url = getUrl(searchFilters);  
  return await axios
    .get<any>(url, { signal })
    .then(callback)
    .catch(error);
};

// id can be the clinic id or the account id
export const QuerySingleApi = async (id: string, lang: string="en", signal: AbortSignal, callback: (response: AxiosResponse) => void, error: (error: any) => void) => {
  const url = getSingleUrl(id, lang);
  return await axios
    .get<any>(url, { signal })
    .then(callback)
    .catch(error);
};

// id can be the clinic id or the account id
export const QueryMultiApi = async (ids: string[], lang: string="en", signal: AbortSignal, callback: (response: AxiosResponse) => void, error: (error: any) => void) => {
  //TODO: replace this with more efficient call when api has one
  ids.forEach(async (id) => {
    const url = getSingleUrl(id, lang);
    await axios
      .get<any>(url, { signal })
      .then(callback)
      .catch(error);
  });
};

export const QueryLookupTablesApi = async (params: LookupTablesApiParameters, signal: AbortSignal, callback: (response: AxiosResponse) => void, error: (error: any) => void) => {
  const url = getTablesUrl(params);  
  return await axios
    .get<any>(url, { signal })
    .then(callback)
    .catch(error);
};